<template>
  <div class="post">
    <h3>{{ pick.title }}</h3>
    <div class="meta">
      <span class="category">{{ pick.sport.sport }}</span>
      <span class="date">{{ pick.date }}</span>
    </div>
    <p v-html="pick.content"></p>
    <b>{{ pick.pick }}</b>
        &nbsp; &nbsp;
    <b>{{ pick.side }}</b>
        &nbsp; &nbsp;
    <b>{{ pick.price }}</b>
        &nbsp; &nbsp;
    <b>{{ pick.units }}</b>
    &nbsp;
    <b>{{ pick.units > 1 ? 'units' : 'unit' }}</b>
  </div>
</template>

<script>
export default {
  props: ['pick'],
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// pick.vue?49c1c464